import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://rvhjosryqvrveuzveooa.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJ2aGpvc3J5cXZydmV1enZlb29hIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTY1MzIzOTIsImV4cCI6MjAzMjEwODM5Mn0.1IIERuSSeSLdJAptU-3682aHfycIK6IIDsBOa0jVwvk';
export const supabase = createClient(supabaseUrl, supabaseKey);
